/* Brunnen Ad Element: GA4-Promotion-Events in den dataLayer.
   view_promotion = mind. 50 % sichtbar für 1 s (einmal pro Element und Seitenaufruf)
   select_promotion = Klick auf das Element */
(function () {
  if (window.__brunnenAdTracking) return;
  window.__brunnenAdTracking = true;
  window.dataLayer = window.dataLayer || [];

  function promo(el) {
    return {
      promotion_id: el.dataset.brunnenAd,
      promotion_name: el.dataset.promoName,
      creative_name: el.dataset.promoCreative,
      creative_slot: el.dataset.promoSlot
    };
  }
  function push(event, el) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: event, ecommerce: { items: [promo(el)] } });
  }

  var seen = new WeakSet();
  var timers = new WeakMap();
  var io = 'IntersectionObserver' in window && new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var el = e.target;
      if (seen.has(el)) return;
      if (e.isIntersecting) {
        timers.set(el, setTimeout(function () {
          seen.add(el);
          io.unobserve(el);
          push('view_promotion', el);
        }, 1000));
      } else {
        clearTimeout(timers.get(el));
      }
    });
  }, { threshold: 0.5 });

  function scan() {
    if (!io) return;
    document.querySelectorAll('[data-brunnen-ad]:not([data-ad-observed])').forEach(function (el) {
      el.setAttribute('data-ad-observed', '');
      io.observe(el);
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-brunnen-ad]');
    if (el) push('select_promotion', el);
  }, true);

  scan();
  // Filter/Sortierung/"Mehr laden" ersetzen das Raster per AJAX
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
